export default {
    formatDate: (value, dateStyle = "short", showTime) => {
        if (value === 0 && !value) return "";

        // EXAMPLE (en locale):
        // short:          6/23/2021
        // short-compact:  6/23 or 6/23/2020 (if not current year)
        // long:           June 23, 2021
        // long-compact:   June 23 or June 23, 2020 (if not current year)
        // time-only:      01:32 PM
        // compact:        00:32 PM or long-compact date (if not current day)

        const thisYear = (new Date(value).getFullYear() === new Date().getFullYear());
        const thisDay = (new Date(value).setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0));

        if (dateStyle === "compact") {
            dateStyle = thisDay ? "time-only" : "long-compact";
            showTime = true;
        }

        if (dateStyle === "time-only") return new Date(value).toLocaleTimeString("default", { hour: "2-digit", minute: "2-digit" });

        return new Date(value).toLocaleDateString("default", {
            year: !dateStyle.match(/compact$/) || !thisYear ? "numeric" : undefined,
            month: dateStyle.match(/^short/) ? "numeric" : "long",
            day: "numeric",
            hour: showTime ? "2-digit" : undefined,
            minute: showTime ? "2-digit" : undefined
        });
    },
    formatTime: (timeInMs, withMilliseconds) => {
        if (timeInMs === 0) return `00:00${withMilliseconds ? ".00" : ""}`;

        const minutes = Math.floor((timeInMs / 1000) / 60);
        const seconds = Math.floor((timeInMs / 1000) % 60);
        const milliseconds = Math.round((timeInMs % 1000) / 10);

        const formattedTime = `${minutes > 9 ? minutes : "0" + minutes}:${seconds > 9 ? seconds : "0" + seconds}`;

        if (withMilliseconds) {
            return `${formattedTime}.${milliseconds > 9 ? milliseconds : "0" + milliseconds}`;
        }

        return formattedTime;
    },
    formatFileSize: (bytes, decimals) => {
        if (bytes === 0 || bytes === undefined) return "";
        if (isNaN(parseFloat(bytes)) && !isFinite(bytes)) return "Not an number";
        const k = 1024;
        const dm = decimals != null && !isNaN(decimals) && decimals >= 0 ? decimals : 2;
        const sizes = ["B", "KB", "MB", "GB", "TB"];
        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    }
};
